var map = {
	"./13August_world_organ (1).jpeg": 10425,
	"./13August_world_organ (2).jpeg": 15118,
	"./WhatsApp Image 2025-01-30 at 1.37.54 PM.jpeg": 95931,
	"./WhatsApp Image 2025-01-30 at 1.37.58 PM.jpeg": 90775,
	"./WhatsApp Image 2025-01-30 at 1.38.06 PM (1).jpeg": 3017,
	"./WhatsApp Image 2025-01-30 at 1.38.06 PM.jpeg": 65827,
	"./WhatsApp Image 2025-01-30 at 1.38.07 PM (1).jpeg": 29688,
	"./WhatsApp Image 2025-01-30 at 1.38.07 PM (2).jpeg": 36983,
	"./WhatsApp Image 2025-01-30 at 1.38.07 PM.jpeg": 65822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42436;